import React from 'react';
import styles from '../styles/page_not_found.scss';


export const PageNotFound = props => {
    return (
        <div className={styles.notFoundContainer}>
            <div className={styles.errorMessage}>Page not found!</div>
            <div className={styles.errorNumContainer}>
                <div className={styles.errorNumber}>4</div>
                <div className={styles.errorNumber + " " + styles.withMargin}>0</div>
                <div className={styles.errorNumber}>4</div>
            </div>
        </div>
    )
};
